import React from "react";

const BlogSkeleton = ({ count = 6 }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="col-md-6 col-sm-6 col-12">
                    <div className="blog_col skeleton">
                        <div className="blog_image skeleton-box"></div>
                        <div className="blog_text">
                            <div className="skeleton-line title"></div>
                            <div className="skeleton-line"></div>
                            <div className="skeleton-line short"></div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default BlogSkeleton;
